/*
* @描述: 订单售后
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/17 17:03
*/
<template>
    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                 :show="dialogVisible"
                 class-name="after_sale_overlay">
        <ul v-if="!order_after_sale_type" class="after_sale_type_list">
            <li class="after_sale_type_title">
                <span class="title">订单售后</span>
                <van-icon name="cross" @click="handleDialogClose"/>
            </li>
            <li v-for="item in after_sale_type_list"
                :key="item.value"
                class="after_sale_type_item"
                @click="handleClickAfterSaleType(item.value)">
                <div class="flex_wrap">
                    <i :class="item.icon" class="iconfont"></i>
                    <span class="type_name" v-text="item.title"></span>
                    <el-tag
                            v-if="item.value==='order_equipment_return'||item.value==='order_renewal'||item.value==='order_rental_to_sale'"
                            size="mini" type="warning">仅租借产品
                    </el-tag>
                </div>
                <div class="desc" v-text="item.desc"></div>
            </li>
        </ul>
        <!--退货-->
        <van-popup v-if="orderReturnGoodsDialog"
                   v-model.sync="orderReturnGoodsDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickReturnGoodsDialogClose">
                    </ReturnNavBar>
                    <div class="returnNavBarRight">
                        <div v-if="!orderReturnGoodsNextStep" class="link-label" @click="handleClickReturnAllGoods">
                            全部退货
                        </div>
                    </div>
                </div>
                <div :style="{'padding-top': orderReturnGoodsNextStep?'0':'10px'}" class="detail_wrap_container">
                    <ul v-if="!orderReturnGoodsNextStep" class="m_order_goods_list">
                        <li v-for="(row,index) in orderDetailsData.order_goods" class="m_order_goods_item">
                            <div class="flex_wrap table_goods_info_wrap">
                                <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                    <img v-if="row.deliver_status == 1"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                    <img v-else-if="row.deliver_status == 2"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                    <img v-else-if="row.deliver_status == 3"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                </div>
                                <img
                                        :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                        alt=""
                                        class="goods_image">
                                <div style="flex: 1">
                                    <div class="goods_name_wrap">
                                        <span v-text="row.goods_name"></span>
                                        <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                              v-text="'：'+row.goods_sku_name"></span>
                                        <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                            {{ row.type === 1 ? '销售' : '租借' }}
                                        </el-tag>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <div>
                                            <span class="goods_price" v-text="'¥'+row.price.value"></span>
                                            <span class="goods_unit" v-text="row.unit?'/'+row.unit:'/个'"></span>
                                        </div>
                                        <span v-text="'X' + row.num"></span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                <ul class="goods_spec_list">
                                    <template v-if="row.is_expand">
                                        <li v-for="child in row._child"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="child in row._child.slice(0,1)"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                </ul>
                                <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                    <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                       class="iconfont"></i>
                                </div>
                            </div>
                            <van-field input-align="right"
                                       label="退货数量"
                                       name="return_num"
                                       type="number">
                                <template #input>
                                    <van-stepper v-model="row.return_num"
                                                 min="0"
                                                 @change="handleChangeReturnNum(row)"/>
                                </template>
                            </van-field>
                            <van-field v-model="row.refund_subtotal_price"
                                       input-align="right"
                                       label="退货总价"
                                       name="refund_subtotal_price"
                                       @change="handleChangeReturnTotalPrice(row)"></van-field>
                        </li>
                    </ul>
                    <div v-else>
                        <div class="m_page_little_title">
                            <span class="title">退货产品信息</span>
                        </div>
                        <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666">
                            <div class="flex_wrap">
                                <i class="iconfont icon-S_jinggao_shixin"></i>
                                <span class="notice">未发货的商品会自动阻拦出库，已发货的商品请归还于仓库</span>
                            </div>
                        </van-notice-bar>
                        <ul class="m_order_goods_list">
                            <li v-for="(row,index) in orderReturnGoodsForm.return_goods" class="m_order_goods_item">
                                <div class="flex_wrap table_goods_info_wrap">
                                    <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                        <img v-if="row.deliver_status == 1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                        <img v-else-if="row.deliver_status == 2"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                        <img v-else-if="row.deliver_status == 3"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                    </div>
                                    <img
                                            :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                            alt=""
                                            class="goods_image">
                                    <div style="flex: 1">
                                        <div class="goods_name_wrap">
                                            <span v-text="row.goods_name"></span>
                                            <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                  v-text="'：'+row.goods_sku_name"></span>
                                            <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                                {{ row.type === 1 ? '销售' : '租借' }}
                                            </el-tag>
                                        </div>
                                        <div class="flex_js_wrap">
                                            <div>
                                                <span class="goods_amount_label">总价：</span>
                                                <span class="goods_price" v-text="'¥'+row.refund_subtotal_price"></span>
                                            </div>
                                            <span v-text="'X' + row.return_num"></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                        <span class="handle_expand_text"
                                              v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="m_page_little_title">
                            <span class="title">退货产品金额</span>
                        </div>
                        <van-form label-width="7em">
                            <van-field
                                    :value="'¥' + Number(orderDetailsData.total_price.value).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"
                                    class="detail_van_field"
                                    label="订单总金额："
                                    readonly></van-field>
                            <van-field
                                    :value="'¥' + Number(orderDetailsData.actual_repay_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"
                                    class="detail_van_field"
                                    label="已回款金额："
                                    readonly></van-field>
                            <van-field
                                    :value="'¥' + Number(orderReturnGoodsForm.refund_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"
                                    class="detail_van_field"
                                    label="退货商品金额："
                                    readonly></van-field>
                            <van-field v-model="orderReturnGoodsForm.real_refund_amount"
                                       input-align="right"
                                       label="实际退款金额："
                                       placeholder="请输入实际退款金额"
                                       @blur="handleRealityRefundAmountBlur">
                            </van-field>
                            <p class="hint_text" v-text="systemHintText"></p>
                        </van-form>
                        <div class="m_page_little_title">
                            <span class="title">其他信息</span>
                        </div>
                        <van-form ref="orderReturnGoodsForm"
                                  error-message-align="right"
                                  input-align="right">
                            <div v-if="Number(orderReturnGoodsForm.real_refund_amount)>0">
                                <van-field v-model="orderReturnGoodsForm.refund_account_name"
                                           :rules="orderReturnGoodsFormRules.refund_account_name"
                                           label="开户名："
                                           name="refund_account_name"
                                           placeholder="请输入开户名"
                                           required></van-field>
                                <van-field v-model="orderReturnGoodsForm.refund_card_number"
                                           :rules="orderReturnGoodsFormRules.refund_card_number"
                                           label="开户账号："
                                           name="refund_card_number"
                                           placeholder="请输入开户账号"
                                           required></van-field>
                                <van-field v-model="orderReturnGoodsForm.refund_bank_name"
                                           :rules="orderReturnGoodsFormRules.refund_bank_name"
                                           label="开户行："
                                           name="refund_bank_name"
                                           placeholder="请输入开户行"
                                           required></van-field>
                            </div>
                            <div class="vertical_input_wrap">
                                <van-field v-model="orderReturnGoodsForm.remarks"
                                           :rules="orderReturnGoodsFormRules.remarks"
                                           error-message-align="left"
                                           label="退货原因："
                                           maxlength="255"
                                           name="refund_remark"
                                           placeholder="请输入退货原因"
                                           required
                                           type="textarea"></van-field>
                            </div>
                        </van-form>
                        <div v-if="isApproval===1">
                            <div class="m_page_little_title">
                                <span class="title">审批流程</span>
                            </div>
                            <div class="add_approval_select_process">
                                <approveProcessSelect ref="approveProcessSelectRef"
                                                      :approval_node_list="approval_node_list">
                                </approveProcessSelect>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="orderReturnGoodsNextStep" class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickReturnGoodsDialogConfirm">提交
                    </van-button>
                </div>
                <div v-else class="next_step_btn_wrap">
                    <div>
                        <div v-if="returnGoodsTotalNum>0">
                            <span>已选</span>
                            <span class="total_text" v-text="returnGoodsTotalNum"></span>
                            <span>个商品</span>
                            <span class="line"></span>
                            <span>共计</span>
                            <span class="total_amount" v-text="'¥' + returnGoodsTotalPrice"></span>
                            <span>元</span>
                        </div>
                    </div>
                    <el-button size="small" type="primary" @click="handleClickReturnGoodsNextStep">下一步</el-button>
                </div>
            </div>
        </van-popup>
        <!--损坏换新-->
        <van-popup v-if="orderExchangeGoodsDialog"
                   v-model.sync="orderExchangeGoodsDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickExchangeGoodsDialogClose">
                    </ReturnNavBar>
                </div>
                <div class="detail_wrap_container pt_10">
                    <ul v-if="!orderExchangeGoodsNextStep" class="m_order_goods_list">
                        <li v-for="(row,index) in orderExchangeGoods" class="m_order_goods_item">
                            <div class="flex_wrap table_goods_info_wrap">
                                <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                    <img v-if="row.deliver_status == 1"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                    <img v-else-if="row.deliver_status == 2"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                    <img v-else-if="row.deliver_status == 3"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                </div>
                                <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                     alt=""
                                     class="goods_image">
                                <div style="flex: 1">
                                    <div class="goods_name_wrap">
                                        <span v-text="row.goods_name"></span>
                                        <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                              v-text="'：'+row.goods_sku_name"></span>
                                        <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                            {{ row.type === 1 ? '销售' : '租借' }}
                                        </el-tag>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <div></div>
                                        <span v-text="'X' + row.num"></span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                <ul class="goods_spec_list">
                                    <template v-if="row.is_expand">
                                        <li v-for="child in row._child"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="child in row._child.slice(0,1)"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                </ul>
                                <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                    <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                       class="iconfont"></i>
                                </div>
                            </div>
                            <div v-if="row.goods_type==='bundle'">
                                <van-field input-align="right"
                                           label="换新产品"
                                           name="exchange_num"
                                           type="number">
                                    <template #button>
                                        <el-link
                                                :disabled="row.max_op_num===0&&row._child.every(child=>child.max_op_num===0)"
                                                :underline="false"
                                                :type="'primary'"
                                                @click="handleClickExchangeGoodsPart(row)"
                                                type="primary">换新产品选择
                                        </el-link>
                                    </template>
                                </van-field>
                                <div class="hint">
                                    此产品包含多个产品，默认全换，如只需更换部分产品，请点击“换新产品选择”
                                </div>
                            </div>
                            <van-field input-align="right"
                                       label="换新产品"
                                       name="exchange_num"
                                       v-else
                                       type="number">
                                <template #input>
                                    <van-stepper v-model="row.exchange_num"
                                                 :disabled="row.max_op_num===0"
                                                 :max="row.max_op_num"
                                                 :min="0"/>
                                </template>
                            </van-field>
                        </li>
                    </ul>
                    <div v-else>
                        <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666">
                            <div class="flex_wrap">
                                <i class="iconfont icon-S_jinggao_shixin"></i>
                                <span class="notice">请确认下方换新产品是否正确，确认无误提交后请将换新的旧产品归还仓库</span>
                            </div>
                        </van-notice-bar>
                        <ul class="m_order_goods_list">
                            <li v-for="(row,index) in orderExchangeGoodsForm.exchange_goods" class="m_order_goods_item">
                                <div class="flex_wrap table_goods_info_wrap">
                                    <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                         alt=""
                                         class="goods_image">
                                    <div style="flex: 1">
                                        <div class="goods_name_wrap">
                                            <span v-text="row.goods_name"></span>
                                            <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                  v-text="'：'+row.goods_sku_name"></span>
                                            <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                                {{ row.type === 1 ? '销售' : '租借' }}
                                            </el-tag>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                                <div class="exchange_goods_wrap">
                                    <div class="exchange_goods_label">换新产品：</div>
                                    <ul v-if="row.goods_type==='bundle'" class="exchange_goods_list">
                                        <li v-for="child in row._child" class="exchange_goods_item">
                                            <span v-text="child.part_name + '：' +child.goods_sku_name"></span>
                                            <span v-text="'*' + child.exchange_num"></span>
                                        </li>
                                    </ul>
                                    <div v-else class="exchange_goods_item">
                                        <span v-text="row.goods_name"></span>
                                        <span v-text="'*'+row.exchange_num"></span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <van-form ref="orderExchangeGoodsForm"
                                  error-message-align="right"
                                  input-align="right">
                            <div class="vertical_input_wrap">
                                <van-field v-model="orderExchangeGoodsForm.remarks"
                                           :rules="orderExchangeGoodsFormRules.remarks"
                                           error-message-align="left"
                                           label="换货原因："
                                           maxlength="255"
                                           name="remarks"
                                           placeholder="请输入换货原因"
                                           required
                                           type="textarea"></van-field>
                            </div>
                        </van-form>
                        <div v-if="isApproval===1">
                            <div class="m_page_little_title">
                                <span class="title">审批流程</span>
                            </div>
                            <div class="add_approval_select_process">
                                <approveProcessSelect ref="approveProcessSelectRef"
                                                      :approval_node_list="approval_node_list">
                                </approveProcessSelect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                v-if="orderExchangeGoodsNextStep"
                                @click="handleClickExchangeGoodsDialogConfirm">提交
                    </van-button>
                    <van-button size="large"
                                type="primary"
                                v-else
                                @click="handleClickExchangeGoodsNextStep">下一步
                    </van-button>
                </div>
            </div>
            <van-popup v-if="exchangeGoodsPartVisible"
                       v-model.sync="exchangeGoodsPartVisible"
                       :style="{ width: '100%',height: '100%' }">
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar :isAllFunctions="false"
                                      :isCustomReturnEvent="true"
                                      :isTitleNormal="true"
                                      title="返回"
                                      @returnEvent="exchangeGoodsPartVisible=false">
                        </ReturnNavBar>
                        <div class="returnNavBarRight">
                            <el-link :underline="false" type="primary"
                                     @click="handleClickClearAllNum">
                                清空数量
                            </el-link>
                        </div>
                    </div>
                    <div class="detail_wrap_container pt_10">
                        <van-field label="更换整体"
                                   class="mb_8"
                                   input-align="right">
                            <template #input>
                                <el-input-number v-model="bundle_goods.exchange_num"
                                                 :disabled="bundle_goods.max_op_num===0"
                                                 :max="bundle_goods.max_op_num"
                                                 :min="0"
                                                 :step="1"
                                                 size="mini"
                                                 step-strictly
                                                 @change="handleChangeAllExchangeNum">
                                </el-input-number>
                            </template>
                        </van-field>
                        <ul>
                            <li v-for="child in bundle_goods._child"
                                :key="child.part_id">
                                <van-field :label="child.part_name + '：' +child.goods_sku_name"
                                           label-width="20em"
                                           input-align="right">
                                    <template #input>
                                        <van-stepper v-model="child.exchange_num"
                                                     :disabled="child.max_op_num===0"
                                                     :max="child.max_op_num"
                                                     :min="0"
                                                     @change="handleChangeChildExchangeNum"/>
                                    </template>
                                </van-field>
                            </li>
                        </ul>
                    </div>
                    <div class="add_footer_wrap">
                        <van-button size="large"
                                    type="primary"
                                    @click="handleClickExchangeConfirm">确定
                        </van-button>
                    </div>
                </div>
            </van-popup>
        </van-popup>
        <!--退款-->
        <van-popup v-if="orderRefundDialog"
                   v-model.sync="orderRefundDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickRefundDialogClose">
                    </ReturnNavBar>
                </div>
                <div class="detail_wrap_container">
                    <div class="detail_chunk_wrap mb_8">
                        <div class="m_detail_form_item mb_8">
                            <div class="form_item_label">订单总金额：</div>
                            <div class="form_item_value"
                                 v-text="'¥' + Number(refundApplyInfo.total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></div>
                        </div>
                        <div class="m_detail_form_item mb_8">
                            <div class="form_item_label">当前实际回款金额：</div>
                            <div class="form_item_value"
                                 v-text="'¥' +Number(refundApplyInfo.repay_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></div>
                        </div>
                        <div class="m_detail_form_item">
                            <div class="form_item_label">总退款金额：</div>
                            <div class="form_item_value"
                                 v-text="'¥' +Number(refundApplyInfo.refund_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></div>
                        </div>
                    </div>
                    <van-form ref="orderRefundForm"
                              input-align="right"
                              error-message-align="right">
                        <van-field label="" input-align="left">
                            <template #input>
                                <el-radio-group v-model="orderRefundForm.apply_type"
                                                @change="handleChangeRefundPriceType">
                                    <el-radio :label="1">退款已回款金额</el-radio>
                                    <el-radio :label="2">自定义填写退款金额</el-radio>
                                </el-radio-group>
                            </template>
                        </van-field>
                        <ul class="relate_repay_list" v-if="orderRefundForm.apply_type === 1">
                            <li class="relate_repay_item"
                                @click="handleClickRelateRepayItem(row)"
                                v-for="row in refundApplyInfo.relate_repay">
                                <div class="relate_repay_item_header">
                                    <div class="flex_wrap">
                                        <van-checkbox v-model="row.checked"></van-checkbox>
                                        <span v-text="row.receivable_no" class="receivable_no"></span>
                                    </div>
                                    <div class="payment_date" v-text="row.payment_date"></div>
                                </div>
                                <div class="relate_repay_item_content">
                                    <div class="flex_wrap">
                                        <span class="field_label">回款金额：</span>
                                        <span class="field_value"
                                              v-text="'¥' +Number(row.payment_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                                    </div>
                                    <div class="flex_wrap">
                                        <span class="field_label">回款方式：</span>
                                        <span class="field_value" v-text="row.payment_method_name"></span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <van-field label="退款金额"
                                   required
                                   name="refund_amount"
                                   v-model="orderRefundForm.refund_amount"
                                   @blur="handleRefundAmountBlur"
                                   :rules="orderRefundFormRules.refund_amount"
                                   :readonly="orderRefundForm.apply_type === 1"
                                   :placeholder="orderRefundForm.apply_type === 2 ? '请输入退款金额' : '请选择回款编号'"></van-field>
                        <van-field label="退款日期"
                                   name="refund_date"
                                   readonly
                                   required
                                   placeholder="请选择退款日期"
                                   @click="showDateCalendar=true"
                                   :value="orderRefundForm.refund_date"
                                   is-link>
                        </van-field>
                        <van-field label="退款类型"
                                   name="refund_type"
                                   readonly
                                   is-link
                                   required
                                   placeholder="请选择退款类型"
                                   @click="showRadioPicker=true"
                                   :rules="orderRefundFormRules.refund_type"
                                   :value="orderRefundForm.refund_type_name">
                        </van-field>
                        <van-field label="开户名"
                                   name="refund_account_name"
                                   placeholder="请输入开户名"
                                   required
                                   :rules="orderRefundFormRules.refund_account_name"
                                   v-model="orderRefundForm.refund_account_name"></van-field>
                        <van-field label="开户账号"
                                   name="refund_card_number"
                                   placeholder="请输入开户账号"
                                   required
                                   :rules="orderRefundFormRules.refund_card_number"
                                   v-model="orderRefundForm.refund_card_number"></van-field>
                        <van-field label="开户行"
                                   name="refund_bank_name"
                                   required
                                   placeholder="请输入开户行"
                                   :rules="orderRefundFormRules.refund_bank_name"
                                   v-model="orderRefundForm.refund_bank_name"></van-field>
                        <div class="vertical_input_wrap">
                            <van-field label="退款原因"
                                       name="remarks"
                                       v-model="orderRefundForm.remarks"
                                       :rules="orderRefundFormRules.remarks"
                                       required
                                       error-message-align="left"
                                       maxlength="255"
                                       placeholder="请输入退款原因"
                                       type="textarea">
                            </van-field>
                        </div>
                    </van-form>
                    <div v-if="isApproval===1">
                        <div class="m_page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <div class="add_approval_select_process">
                            <approveProcessSelect ref="approveProcessSelectRef"
                                                  :approval_node_list="approval_node_list">
                            </approveProcessSelect>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickRefundDialogConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>
        <!--归还-->
        <van-popup v-if="orderEquipmentReturnDialog"
                   v-model.sync="orderEquipmentReturnDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickReturnDialogClose">
                    </ReturnNavBar>
                </div>
                <div class="detail_wrap_container pt_10">
                    <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666">
                        <div class="flex_wrap">
                            <i class="iconfont icon-S_jinggao_shixin"></i>
                            <span class="notice">只可归还订单中已出库的租借产品，若当前产品未完全出库，请联系仓库管理员，虚拟物品无需归还</span>
                        </div>
                    </van-notice-bar>
                    <ul class="m_order_goods_list">
                        <li v-for="(row,index) in orderEquipmentReturnGoods" class="m_order_goods_item">
                            <div class="flex_wrap table_goods_info_wrap">
                                <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                    <img v-if="row.deliver_status == 1"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                    <img v-else-if="row.deliver_status == 2"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                    <img v-else-if="row.deliver_status == 3"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                </div>
                                <img
                                        :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                        alt=""
                                        class="goods_image">
                                <div class="goods_name_wrap" style="flex: 1">
                                    <span v-text="row.goods_name"></span>
                                    <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                          v-text="'：'+row.goods_sku_name"></span>
                                </div>
                            </div>
                            <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                <ul class="goods_spec_list">
                                    <template v-if="row.is_expand">
                                        <li v-for="child in row._child"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="child in row._child.slice(0,1)"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                </ul>
                                <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                    <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                       class="iconfont"></i>
                                </div>
                            </div>
                            <div class="return_good_num">
                                <div class="flex_wrap">
                                    <span class="field_label">产品总数量：</span>
                                    <span class="field_value" v-text="row.num"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">待归还数量：</span>
                                    <span class="field_value" v-text="row.max_op_num"></span>
                                </div>
                            </div>
                            <van-field input-align="right"
                                       label="本次归还数量"
                                       name="return_num"
                                       label-width="12em"
                                       type="number">
                                <template #label>
                                    <div class="flex_wrap">
                                        <span>本次归还数量</span>
                                        <el-link v-if="row.goods_type==='bundle'&&row.hasOwnProperty('_child')"
                                                 :underline="false"
                                                 type="primary"
                                                 @click="handleClickReturnAccessories(row)">配件归还
                                        </el-link>
                                    </div>
                                </template>
                                <template #input>
                                    <van-stepper v-model="row.equipment_return_num"
                                                 :disabled="row.max_op_num===0"
                                                 :max="row.max_op_num"
                                                 :min="0"
                                                 @change="handleGoodsReturnNumChange(row)"/>
                                </template>
                            </van-field>
                        </li>
                    </ul>
                    <div v-if="isApproval===1">
                        <div class="m_page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <div class="add_approval_select_process">
                            <approveProcessSelect ref="approveProcessSelectRef"
                                                  :approval_node_list="approval_node_list">
                            </approveProcessSelect>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickReturnDialogConfirm">提交
                    </van-button>
                </div>
            </div>
            <van-popup v-if="returnAccessoriesDialog"
                       v-model.sync="returnAccessoriesDialog"
                       :style="{ width: '100%',height: '100%' }">
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar :isAllFunctions="false"
                                      :isCustomReturnEvent="true"
                                      :isTitleNormal="true"
                                      title="返回"
                                      @returnEvent="handleClickReturnAccessoriesDialogClose">
                        </ReturnNavBar>
                    </div>
                    <div class="detail_wrap_container pt_10">
                        <ul class="returna_ccessories_list">
                            <li class="returna_ccessories_item" v-for="row in returnAccessoriesList">
                                <div class="goods_sku_name" v-text="row.goods_sku_name"></div>
                                <div class="flex_js_wrap">
                                    <div>
                                        <span class="field_label">待归还数量：</span>
                                        <span class="field_value" v-text="row.max_op_num"></span>
                                    </div>
                                    <van-stepper v-model="row.equipment_return_num"
                                                 :min="0"
                                                 :disabled="row.max_op_num===0"
                                                 :max="row.max_op_num"/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="add_footer_wrap">
                        <van-button size="large"
                                    type="primary"
                                    @click="handleClickReturnAccessoriesDialogConfirm">提交
                        </van-button>
                    </div>
                </div>
            </van-popup>
        </van-popup>
        <!--续租-->
        <van-popup v-if="orderRenewalDialog"
                   v-model.sync="orderRenewalDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickRenewDialogClose">
                    </ReturnNavBar>
                    <div>
                        <el-link :underline="false" type="primary" @click="handleClickBatchRenewDate">批量变更</el-link>
                    </div>
                </div>
                <div class="detail_wrap_container pt_10">
                    <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666" style="height: 60px">
                        <div class="flex_wrap">
                            <i class="iconfont icon-S_jinggao_shixin"></i>
                            <span class="notice">仅订单中租借的产品可以进行续租；<br>续租后，提醒时间会根据续租后时间判定，续租后可提前归还；涉及价格更改可以通过《编辑订单》处理！</span>
                        </div>
                    </van-notice-bar>
                    <van-form ref="orderRenewalForm">
                        <ul class="m_order_goods_list">
                            <li v-for="(row,index) in orderDetailsData.order_goods" class="m_order_goods_item">
                                <div class="flex_wrap table_goods_info_wrap">
                                    <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                        <img v-if="row.deliver_status == 1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                        <img v-else-if="row.deliver_status == 2"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                        <img v-else-if="row.deliver_status == 3"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                    </div>
                                    <img
                                            :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                            alt=""
                                            class="goods_image">
                                    <div class="goods_name_wrap" style="flex: 1">
                                        <span v-text="row.goods_name"></span>
                                        <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                              v-text="'：'+row.goods_sku_name"></span>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                                <van-field label="当前到期时间"
                                           readonly
                                           input-align="right"
                                           :value="row.end_at">
                                </van-field>
                                <van-field label="续租/变更时间"
                                           input-align="right"
                                           label-width="8em"
                                           is-link
                                           readonly
                                           placeholder="请选择续租时间"
                                           @click="handleClickSelectRenewalDate(row)"
                                           :value="row.renewal_date">
                                </van-field>
                            </li>
                        </ul>
                        <div class="vertical_input_wrap">
                            <van-field label="续租说明"
                                       name="remarks"
                                       v-model="orderRenewalForm.remarks"
                                       :rules="orderRenewalFormRules.remarks"
                                       required
                                       error-message-align="left"
                                       maxlength="255"
                                       placeholder="请输入续租说明"
                                       type="textarea">
                            </van-field>
                        </div>
                    </van-form>
                    <div v-if="isApproval===1">
                        <div class="m_page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <div class="add_approval_select_process">
                            <approveProcessSelect ref="approveProcessSelectRef"
                                                  :approval_node_list="approval_node_list">
                            </approveProcessSelect>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickRenewDialogConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>
        <!--租借转销售-->
        <van-popup v-if="orderLeaseForSaleDialog"
                   v-model.sync="orderLeaseForSaleDialog"
                   :style="{ width: '100%',height: '100%' }">
            <div class="public_container" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickLeaseForSaleDialogClose">
                    </ReturnNavBar>
                    <div>
                        <el-link :underline="false" type="primary" @click="handleClickAllForSale">全部销售</el-link>
                    </div>
                </div>
                <div class="detail_wrap_container pt_10">
                    <div v-if="!orderLeaseForSaleNextStep">
                        <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666">
                            <div class="flex_wrap">
                                <i class="iconfont icon-S_jinggao_shixin"></i>
                                <span class="notice">转销售后，原订单中的产品由租借变为销售，且此行为不可逆</span>
                            </div>
                        </van-notice-bar>
                        <ul class="m_order_goods_list" v-if="orderDetailsData.order_goods.length">
                            <li v-for="(row,index) in orderDetailsData.order_goods.filter(goods=>goods.type===2)"
                                class="m_order_goods_item">
                                <div class="flex_wrap table_goods_info_wrap">
                                    <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                        <img v-if="row.deliver_status == 1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                        <img v-else-if="row.deliver_status == 2"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                        <img v-else-if="row.deliver_status == 3"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                    </div>
                                    <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                         alt=""
                                         class="goods_image">
                                    <div style="flex: 1">
                                        <div class="goods_name_wrap">
                                            <span v-text="row.goods_name"></span>
                                            <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                  v-text="'：'+row.goods_sku_name"></span>
                                        </div>
                                        <div class="flex_js_wrap">
                                            <div></div>
                                            <span v-text="'X' + row.num"></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                                <van-field label="转销售数量" input-align="right">
                                    <template #input>
                                        <van-stepper v-model="row.sale_num"
                                                     :disabled="row.is_sale===0||row.type===1"
                                                     :max="row.max_to_sale_num"
                                                     :min="0"
                                                     @change="handleForSaleNumChange(row)">
                                        </van-stepper>
                                    </template>
                                </van-field>
                                <van-field label="销售单价"
                                           input-align="right"
                                           v-model="row.sale_price.text"
                                           :disabled="row.is_sale===0||row.type===1"
                                           placeholder="请输入销售单价"
                                           @blur="handleSalePriceBlur(row)">
                                </van-field>
                                <van-field label="销售总价"
                                           readonly
                                           input-align="right"
                                           :value="row.sale_subtotal_price.text">
                                </van-field>
                            </li>
                        </ul>
                        <div class="total_amount_wrap flex_js_wrap">
                            <span>总计：</span>
                            <span v-text="toSaleTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                        </div>
                    </div>
                    <div v-else>
                        <van-notice-bar background="#FDF1DE" class="mb_8" color="#666666">
                            <div class="flex_wrap">
                                <i class="iconfont icon-S_jinggao_shixin"></i>
                                <span class="notice">转销售后，原订单中的产品由租借变为销售，且此行为不可逆</span>
                            </div>
                        </van-notice-bar>
                        <div class="m_page_little_title">
                            <span class="title">转销售产品信息</span>
                        </div>
                        <ul class="m_order_goods_list">
                            <li v-for="(row,index) in leaseForSaleForm.rental_to_sale_goods"
                                class="m_order_goods_item">
                                <div class="flex_wrap table_goods_info_wrap">
                                    <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                        <img v-if="row.deliver_status == 1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                        <img v-else-if="row.deliver_status == 2"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                        <img v-else-if="row.deliver_status == 3"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                    </div>
                                    <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                         alt=""
                                         class="goods_image">
                                    <div style="flex: 1">
                                        <div class="goods_name_wrap">
                                            <span v-text="row.goods_name"></span>
                                            <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                  v-text="'：'+row.goods_sku_name"></span>
                                        </div>
                                        <div class="flex_js_wrap">
                                            <div>
                                                <span class="goods_price" v-text="'¥'+row.sale_price.text"></span>
                                            </div>
                                            <span v-text="'X' + row.sale_num"></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                                <van-field label="销售总价"
                                           readonly
                                           input-align="right"
                                           :value="'¥'+row.sale_subtotal_price.text">
                                </van-field>
                            </li>
                        </ul>
                        <div class="total_amount_wrap flex_js_wrap">
                            <span>总计：</span>
                            <span v-text="toSaleTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                        </div>
                        <div v-if="leaseForSaleForm.custom_amount_change.length" class="mt_16">
                            <div class="m_page_little_title">
                                <span class="title">订单金额变化</span>
                            </div>
                            <div class="detail_chunk_wrap">
                                <ul class="custom_amount_change_list">
                                    <li v-for="item in leaseForSaleForm.custom_amount_change"
                                        :key="item.field_key" class="custom_amount_change_item">
                                        <div class="custom_amount_field_name" v-text="item.field_name"></div>
                                        <div class="flex_wrap">
                                            <span v-text="item.old_value && item.old_value.text ? item.old_value.text : '--'"></span>
                                            <i class="iconfont icon-youjiantou"></i>
                                            <span v-text="item.new_value && item.new_value.text ? item.new_value.text : '--'"></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="isApproval===1">
                            <div class="m_page_little_title">
                                <span class="title">审批流程</span>
                            </div>
                            <div class="add_approval_select_process">
                                <approveProcessSelect ref="approveProcessSelectRef"
                                                      :approval_node_list="approval_node_list">
                                </approveProcessSelect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                v-if="!orderLeaseForSaleNextStep"
                                @click="handleLeaseForSaleNextStep">下一步
                    </van-button>
                    <van-button size="large"
                                type="primary"
                                v-else
                                @click="handleClickLeaseForSaleDialogConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>

        <!--日期选择-->
        <van-calendar v-model="showDateCalendar"
                      color="#2990FF"
                      :show-confirm="false"
                      :min-date="dateCalendarMin"
                      :max-date="dateCalendarMax"
                      @confirm="handleDateCalenderConfirm"/>
        <!--单选弹窗-->
        <van-popup v-model="showRadioPicker" round position="bottom">
            <van-picker show-toolbar
                        value-key="label"
                        :columns="currentRadiooptions"
                        @cancel="showRadioPicker = false"
                        @confirm="handleClickRadioOption"/>
        </van-popup>
    </van-overlay>
</template>
<script>
import {
    orderAfterSaleType,
    orderDetail,
    afterSalesExchange,
    afterSalesRefund,
    afterSalesRefundInfo,
    afterSalesReturn,
    getApprovalNodes,
    getExchangeGoods,
    getEquipmentReturnGoods,
    afterSalesEquipmentReturn,
    afterSalesRenewal,
    afterSalesRentalToSale,
} from "@/api";
import {calculate, formatDate, getBusinessIsApproval, getNowDate} from "@/utils";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "orderAfterSale",
    data() {
        return {
            after_sale_type_list: [],
            orderReturnGoodsDialog: false,
            orderReturnGoodsNextStep: false,
            orderReturnGoodsForm: {
                return_goods: [],//退款商品
                refundable_amount: '',//应退货金额
                refund_amount: '',//退货商品总金额
                real_refund_amount: '',//实际退款金额
                remarks: '', //退货原因
                custom_amount_change: {},
                goods_cost_price: 0, //变更后总成本金额
                refund_account_name: "",
                refund_card_number: "",
                refund_bank_name: "",
                total_price: {
                    value: 0,
                    text: "",
                    value_converted: 0,
                    currency: "CNY"
                }
            },
            orderReturnGoodsFormRules: {
                remarks: [{required: true, message: '请输入退货原因', trigger: 'onBlur'}],
                refund_account_name: [{required: true, message: '请输入开户名', trigger: 'onBlur'}],
                refund_card_number: [{required: true, message: '请输入开户账号', trigger: 'onBlur'}],
                refund_bank_name: [{required: true, message: '请输入开户行', trigger: 'onBlur'}],
            },
            orderExchangeGoodsDialog: false,
            orderExchangeGoods: [],
            orderExchangeGoodsNextStep: false,
            orderExchangeGoodsForm: {
                remarks: '', //换货原因
                exchange_goods: [],
            },
            orderExchangeGoodsFormRules: {
                remarks: [{required: true, message: '请输入换货原因', trigger: 'onBlur'}]
            },
            orderRefundDialog: false,
            orderRefundForm: {
                apply_type: 1,
                refund_amount: '',
                refund_date: '',
                refund_type: '',
                refund_type_name: '',
                refund_account_name: '',
                refund_card_number: '',
                refund_bank_name: '',
                remarks: '',
                relate_repay: [],
            },
            orderRefundFormRules: {
                refund_amount: [
                    {
                        required: true,
                        trigger: 'onBlur',
                        message: '请输入退款金额',
                        validator: (value) => {
                            return value !== ''
                        }
                    },
                    {
                        required: true,
                        trigger: 'onChange',
                        message: '退款金额必须大于0',
                        validator: (value) => {
                            return value !== '0.00'
                        }
                    }
                ],
                refund_date: [{required: true, message: '请选择退款日期', trigger: 'onChange'}],
                refund_type: [{required: true, message: '请选择退款类型', trigger: 'onChange'}],
                refund_account_name: [{required: true, message: '请输入开户名', trigger: 'onBlur'}],
                refund_card_number: [{required: true, message: '请输入开户账号', trigger: 'onBlur'}],
                refund_bank_name: [{required: true, message: '请输入开户行', trigger: 'onBlur'}],
                remarks: [{required: true, message: '请输入退款原因', trigger: 'onBlur'}]
            },
            orderEquipmentReturnDialog: false,
            orderRenewalDialog: false,
            orderRenewalForm: {
                remarks: '',
            },
            orderRenewalFormRules: {
                remarks: [{required: true, message: '请输入续租说明', trigger: 'onBlur'}]
            },
            orderLeaseForSaleDialog: false,
            orderLeaseForSaleNextStep: false,
            btnDisabled: false,
            orderDetailsData: {},
            systemHintText: '',
            refundApplyInfo: [],
            approval_node_list: [],
            isApproval: 0,
            loading: false,
            order_amount_compute_mode: [],
            max_refund_amount: 0,
            orderEquipmentReturnGoods: [],
            returnAccessoriesDialog: false,
            returnAccessoriesList: [],
            bundle_goods_id: 0,
            bundle_goods: {},
            batchRenewDateVisible: false,
            leaseForSaleForm: {
                total_price: {
                    value: 0,
                    text: "",
                    value_converted: 0,
                    currency: "CNY"
                },
                goods_cost_price: 0,//变更后总成本金额
                rental_to_sale_goods: [],
                custom_amount_change: []
            },
            exchangeGoodsPartVisible: false,
            showDateCalendar: false,
            showRadioPicker: false,
            dateCalendarMin: new Date('1970-01-01'),
            dateCalendarMax: new Date('2070-01-01'),
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_after_sale_type: {
            type: String,
            default: '',
        },
        order_id: {
            type: Number,
            default: 0,
        },
        orderInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {ReturnNavBar, CustomFormMobile, approveProcessSelect},
    computed: {
        returnGoodsTotalNum() {
            let totalNum = 0
            if (this.orderDetailsData.order_goods) {
                totalNum = this.orderDetailsData.order_goods.reduce((total, goods) => {
                    return total + Number(goods.return_num)
                }, 0)
            }
            return totalNum
        },
        returnGoodsTotalPrice() {
            let totalPrice = 0
            if (this.orderDetailsData.order_goods) {
                totalPrice = this.orderDetailsData.order_goods.reduce((total, goods) => {
                    return total + (goods.refund_subtotal_price ? Number(goods.refund_subtotal_price) : 0)
                }, 0)
            }
            return totalPrice.toFixed(2)
        },
        toSaleTotalAmount() {
            return this.orderDetailsData.order_goods.reduce((total, goods) => {
                return total + (goods.sale_subtotal_price.value ? Number(goods.sale_subtotal_price.value) : 0)
            }, 0)
        },
        currentRadiooptions() {
            if (this.orderRefundDialog) {
                return [
                    {label: '普通退款', value: 'ordinary'},
                    {label: '租金退款', value: 'rent'},
                    {label: '押金退款', value: 'deposit'},
                ]
            }
        }
    },
    created() {
        if (this.order_after_sale_type) {
            this.handleClickAfterSaleType(this.order_after_sale_type)
        }
        orderAfterSaleType().then(res => {
            if (res.code === 200) {
                this.after_sale_type_list = res.data
            }
        })
        getBusinessIsApproval('order_after_sale').then(res => {
            this.isApproval = res
        })
    },
    mounted() {
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //点击售后类型
        handleClickAfterSaleType(type) {
            this.afterSaleType = type
            switch (type) {
                case 'order_edit':
                    this.$emit('order_edit', this.order_id)
                    this.$emit('update:dialogVisible', false)
                    break
                case 'order_return':
                    this.orderReturnGoodsDialog = true
                    this.getOrderDetail()
                    break
                case 'order_exchange':
                    this.orderExchangeGoodsDialog = true
                    this.loading = true
                    getExchangeGoods({
                        order_id: this.order_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.orderExchangeGoods = res.data
                            this.orderExchangeGoods.forEach(item => {
                                this.$set(item, 'exchange_num', 0)
                                if (item._child) {
                                    item._child.forEach(child => {
                                        this.$set(child, 'exchange_num', 0)
                                    })
                                }
                            })
                        }
                        this.loading = false
                    })
                    break
                case 'order_refund':
                    this.orderRefundDialog = true
                    this.orderRefundForm.refund_date = getNowDate()
                    this.getRefundApplyInfo()
                    this.getApprovalNodesList('order_refund')
                    break
                case 'order_equipment_return':
                    this.orderEquipmentReturnDialog = true
                    getEquipmentReturnGoods({
                        order_id: this.order_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.orderEquipmentReturnGoods = res.data
                        }
                    })
                    this.getApprovalNodesList('order_equipment_return')
                    break
                case 'order_renewal':
                    this.orderRenewalDialog = true
                    this.getOrderDetail()
                    this.getApprovalNodesList('order_renewal')
                    break
                case 'order_rental_to_sale':
                    this.orderLeaseForSaleDialog = true
                    this.getOrderDetail()
                    break
            }
        },

        //获取订单详情
        getOrderDetail() {
            this.loading = true
            orderDetail({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData = res.data
                    switch (this.afterSaleType) {
                        case 'order_return':
                            this.orderDetailsData.order_goods.forEach(goods => {
                                this.$set(goods, 'has_return_num', goods.return_num)
                                this.$set(goods, 'return_num', 0)
                                this.$set(goods, 'max_return_num', Number(goods.num) - Number(goods.has_return_num))
                                this.$set(goods, 'refund_subtotal_price', '')
                            })
                            break
                        case 'order_renewal':
                            this.orderDetailsData.order_goods = this.orderDetailsData.order_goods.filter(goods => goods.type === 2)
                            break
                        case 'order_rental_to_sale':
                            this.orderDetailsData.order_goods.forEach(goods => {
                                this.$set(goods, 'max_to_sale_num', Number(goods.num) - Number(goods.return_num))
                                this.$set(goods, 'sale_num', 0)
                                this.$set(goods, 'sale_subtotal_price', {
                                    value: '',
                                    text: '',
                                    value_converted: '',
                                    currency: ''
                                })
                                this.$set(goods, 'sale_price', {
                                    value: '',
                                    text: '',
                                    value_converted: '',
                                    currency: ''
                                })
                            })
                            break
                    }
                    const amount_information = res.data.custom_fields.find(item => item.field_key === 'amount_information')
                    if (amount_information && amount_information._child) {
                        amount_information._child.forEach(child => {
                            if (child.status === 0) {
                                if (child.extend) {
                                    for (let extendKey in child.extend) {
                                        child[extendKey] = child.extend[extendKey];
                                    }
                                }
                                this.order_amount_compute_mode.push(child)
                            }
                        })
                    }
                }
                this.loading = false
            })
        },

        //获取审批节点
        getApprovalNodesList(value) {
            if (this.isApproval === 1) {
                getApprovalNodes({
                    approval_type: 'order_after_sale',
                    form_value: {
                        order_after_sale: {
                            value: value
                        }
                    }
                }).then(res => {
                    if (res.code === 200) {
                        this.approval_node_list = res.data
                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },

        //获取退款发起参考信息
        getRefundApplyInfo() {
            this.loading = true
            afterSalesRefundInfo({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.refundApplyInfo = res.data
                }
                this.loading = false
            })
        },

        //点击全部退货
        handleClickReturnAllGoods() {
            this.orderDetailsData.order_goods.forEach(good => {
                this.$set(good, 'return_num', Number(good.num))
                if (good.return_num > good.max_return_num) {
                    this.$set(good, 'return_num', good.max_return_num)
                } else {
                    this.$set(good, 'total_amount_change_text', '数值发生变化')
                }
                good.refund_subtotal_price = Number(good.price.value * good.return_num).toFixed(2)
            })
        },

        //点击退货下一步
        handleClickReturnGoodsNextStep() {
            if (this.returnGoodsTotalNum === 0) return this.$toast.fail('请添加退货商品')
            this.orderReturnGoodsNextStep = !this.orderReturnGoodsNextStep
            if (this.orderReturnGoodsNextStep) {
                this.orderReturnGoodsForm.return_goods = this.orderDetailsData.order_goods.filter(good => good.return_num > 0)
                this.orderReturnGoodsForm.refund_amount = this.returnGoodsTotalPrice
                //应退货金额
                this.orderReturnGoodsForm.refundable_amount = (this.orderDetailsData.order_goods.reduce((total, goods) => {
                    return total + (Number(goods.price.value) * goods.return_num)
                }, 0)).toFixed(2)
                //变更后订单金额
                const total_price = (Number(this.orderDetailsData.total_price.value) - Number(this.orderReturnGoodsForm.refund_amount)).toFixed(2)
                this.orderReturnGoodsForm.total_price = {
                    value: Number(total_price),
                    value_converted: Number(total_price),
                    text: Number(total_price).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                    currency: 'CNY',
                }
                //变更后总成本金额
                this.orderReturnGoodsForm.goods_cost_price = this.orderDetailsData.order_goods.reduce((sum, item) => sum + parseFloat(item.cost_price) * (item.num - item.return_num), 0).toFixed(2);
                this.returnGoodsOrderAmountInfoComputed('total_price')
                this.returnGoodsOrderAmountInfoComputed('product_cost')
                this.returnGoodsOrderAmountInfoComputed('product_total_price')
                if (this.orderReturnGoodsForm.refund_amount <= Number(this.orderDetailsData.no_repay_price)) {
                    //当前客户退货金额<未回款金额
                    this.orderReturnGoodsForm.real_refund_amount = '0.00'
                    if (this.orderReturnGoodsForm.refund_amount > Number(this.orderDetailsData.repay_price)) {
                        //当前客户退货金额>实际回款金额，区间只能是0 - 当前客户实际回款金额
                        this.systemHintText = "系统提示：当前客户退货金额 < 未回款金额，系统已帮你带出退款金额，可手动更改区间0 - " + this.orderDetailsData.repay_price;
                        this.max_refund_amount = this.orderDetailsData.repay_price;
                    } else {
                        //当前客户退货金额小于等于实际回款金额，区间只能是0 - 当前客户退货金额
                        this.systemHintText = "系统提示：当前客户退货金额 < 未回款金额，系统已帮你带出退款金额，可手动更改区间0 - " + this.orderReturnGoodsForm.refund_amount;
                        this.max_refund_amount = this.orderReturnGoodsForm.refund_amount;
                    }
                } else if (this.orderReturnGoodsForm.refund_amount > Number(this.orderDetailsData.no_repay_price)) {
                    //当前客户退货金额>未回款金额
                    if (this.orderReturnGoodsForm.refund_amount > Number(this.orderDetailsData.repay_price)) {
                        //当前客户退货金额>实际回款金额，区间只能是0 - 当前客户实际回款金额
                        this.systemHintText = '系统当前客户退货金额 > 未回款金额，系统已帮你带出退款金额，可手动更改区间0 - ' + this.orderDetailsData.repay_price
                        this.max_refund_amount = this.orderDetailsData.repay_price;
                    } else {
                        //当前客户退货金额小于等于实际回款金额，区间只能是0 - 当前客户退货金额
                        this.systemHintText = '系统提示：当前客户退货金额 > 未回款金额，系统已帮你带出退款金额，可手动更改区间0 - ' + this.orderReturnGoodsForm.refund_amount
                        this.max_refund_amount = this.orderReturnGoodsForm.refund_amount;
                    }
                    this.orderReturnGoodsForm.real_refund_amount = Number(this.orderDetailsData.no_repay_price) < 0 ? Number(this.orderReturnGoodsForm.refund_amount).toFixed(2) : (this.orderReturnGoodsForm.refund_amount - Number(this.orderDetailsData.no_repay_price)).toFixed(2)
                }
            }
            if (this.approval_node_list.length === 0) {
                this.getApprovalNodesList('order_return')
            }
        },

        //实际退款金额失焦事件
        handleRealityRefundAmountBlur() {
            let val = this.orderReturnGoodsForm.real_refund_amount.replace(/[^\d.]/g, '');
            if (val) {
                if (Number(val) > Number(this.max_refund_amount)) {
                    this.orderReturnGoodsForm.real_refund_amount = this.max_refund_amount
                } else {
                    this.orderReturnGoodsForm.real_refund_amount = Number(val).toFixed(2)
                }
            } else {
                this.orderReturnGoodsForm.real_refund_amount = '0.00'
            }
        },

        //退货数量变化事件
        handleChangeReturnNum(row) {
            this.$nextTick(() => {
                row.refund_subtotal_price = Number(row.price.value * row.return_num).toFixed(2)
                this.$set(row, 'total_amount_change_text', '数值发生变化')
            })
        },

        //退货金额改变
        handleChangeReturnTotalPrice(row) {
            let val = row.refund_subtotal_price.replace(/[^\d.]/g, '');
            if (Number(val) > Number(row.price.value * row.return_num)) {
                row.refund_subtotal_price = Number(row.price.value * row.return_num).toFixed(2)
                this.$set(row, 'total_amount_change_text', '退货金额不得大于退货数量*单价')
            } else {
                row.refund_subtotal_price = Number(val).toFixed(2)
            }
        },

        //点击关闭退货弹窗
        handleClickReturnGoodsDialogClose() {
            if (this.orderReturnGoodsNextStep) {
                this.orderReturnGoodsNextStep = false
            } else {
                this.orderReturnGoodsDialog = false
                this.$emit('update:dialogVisible', false)
            }
        },

        //退货弹窗确认
        handleClickReturnGoodsDialogConfirm() {
            if (Number(this.orderReturnGoodsForm.real_refund_amount) > 0) {
                this.$refs.orderReturnGoodsForm.validate().then(() => {
                    if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                    this.$dialog.confirm({
                        title: '提示',
                        message: '存在退款金额，审批通过后为您自动生成退款，可在订单售后管理查看退款进度！',
                        confirmButtonColor: '#2990ff',
                    }).then(() => {
                        this.btnDisabled = true
                        const data = {
                            order_id: this.order_id,
                            return_goods: this.orderReturnGoodsForm.return_goods.map(item => {
                                return {
                                    order_goods_id: item.order_goods_id,
                                    return_num: item.return_num,
                                    refund_subtotal_price: item.refund_subtotal_price,
                                }
                            }),
                            refundable_amount: this.orderReturnGoodsForm.real_refund_amount,
                            refund_amount: this.orderReturnGoodsForm.refund_amount,
                            real_refund_amount: this.orderReturnGoodsForm.real_refund_amount,
                            remarks: this.orderReturnGoodsForm.remarks,
                            custom_amount_change: this.orderReturnGoodsForm.custom_amount_change,
                            goods_cost_price: this.orderReturnGoodsForm.goods_cost_price,
                            refund_account_name: this.orderReturnGoodsForm.refund_account_name,
                            refund_card_number: this.orderReturnGoodsForm.refund_card_number,
                            refund_bank_name: this.orderReturnGoodsForm.refund_bank_name,
                            total_price: this.orderReturnGoodsForm.total_price,
                            node_list: this.approval_node_list,
                            after_sales_type: '订单售后-退货', //售后类型
                            order_num: this.orderInfo?.order_num,//	订单编号
                            customer_name: this.orderInfo?.customer_name,//关联客户
                        }
                        afterSalesReturn(data).then(res => {
                            if (res.code === 200) {
                                this.$toast.success('退货申请发起成功')
                                this.orderRefundDialog = false
                                this.$emit('update:dialogVisible', false)
                                this.$emit('refresh')
                            }
                            this.btnDisabled = false
                        })
                    }).catch(() => {

                    })
                }).catch(error => {
                    if (error.length) {
                        this.$toast.fail(error[0].message)
                    }
                })
            } else {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                const data = {
                    order_id: this.order_id,
                    return_goods: this.orderReturnGoodsForm.return_goods.map(item => {
                        return {
                            order_goods_id: item.order_goods_id,
                            return_num: item.return_num,
                            refund_subtotal_price: item.refund_subtotal_price,
                        }
                    }),
                    refundable_amount: this.orderReturnGoodsForm.real_refund_amount,
                    refund_amount: this.orderReturnGoodsForm.refund_amount,
                    real_refund_amount: this.orderReturnGoodsForm.real_refund_amount,
                    remarks: this.orderReturnGoodsForm.remarks,
                    custom_amount_change: this.orderReturnGoodsForm.custom_amount_change,
                    goods_cost_price: this.orderReturnGoodsForm.goods_cost_price,
                    refund_account_name: this.orderReturnGoodsForm.refund_account_name,
                    refund_card_number: this.orderReturnGoodsForm.refund_card_number,
                    refund_bank_name: this.orderReturnGoodsForm.refund_bank_name,
                    total_price: this.orderReturnGoodsForm.total_price,
                    node_list: this.approval_node_list,
                    after_sales_type: '订单售后-退货', //售后类型
                    order_num: this.orderInfo?.order_num,//	订单编号
                    customer_name: this.orderInfo?.customer_name,//关联客户
                }
                afterSalesReturn(data).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('退货申请发起成功')
                        this.orderRefundDialog = false
                        this.$emit('update:dialogVisible', false)
                        this.$emit('refresh')
                    }
                    this.btnDisabled = false
                })
            }
        },

        //退货后订单金额信息重新计算
        returnGoodsOrderAmountInfoComputed(field_key) {
            if (this.order_amount_compute_mode.length) {
                this.order_amount_compute_mode.forEach(field => {
                    if (field.field_formula.includes(field_key)) {
                        //拿出公式列表所有type为component的组件
                        const components = field.formula_list.filter(formula => formula.type === 'component' || formula.type === 'product_cost' || formula.type === 'product_total_price' || formula.type === 'purchase_price')
                        if (components.length) {
                            //接口需要的数据
                            const formulaValue = {}
                            components.forEach(component => {
                                if (component.type === 'component') {
                                    if (['order_amount_compute_mode', 'money_compute_mode'].includes(component.field_type)) {
                                        if (component.field_key === 'total_price') {
                                            formulaValue[component.field_key] = Number(this.orderReturnGoodsForm.total_price.value)
                                        } else {
                                            const value = this.orderDetailsData[component.field_key]?.value;
                                            formulaValue[component.field_key] = value !== undefined ? parseFloat(value) : 0;
                                        }
                                    }
                                } else if (component.type === 'product_cost' || component.type === 'product_total_price') {
                                    let filteredGoods = []
                                    if (!component.commodity_value_config || component.commodity_value_config.length === 0) {
                                        filteredGoods = this.orderDetailsData.order_goods
                                    } else {
                                        component.commodity_value_config.forEach(config => {
                                            if (config.type === 'category') {
                                                this.orderDetailsData.order_goods.forEach(good => {
                                                    if (good.category_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            } else if (config.type === 'goods') {
                                                this.orderDetailsData.order_goods.forEach(good => {
                                                    if (good.goods_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    if (field.applicable_products !== 'all') {
                                        const typeMap = {sale: 1, lease: 2};
                                        const productType = typeMap[field.applicable_products];
                                        filteredGoods = filteredGoods.filter(item => item.type === productType);
                                    }
                                    const sumFunc = (sum, item) => sum + (component.type === 'product_cost' ? parseFloat(item.cost_price) * (parseFloat(item.num) - parseFloat(item.return_num)) : parseFloat(item.price.value) * (parseFloat(item.num) - parseFloat(item.return_num)));
                                    formulaValue[component.field_key] = filteredGoods.reduce(sumFunc, 0);
                                } else if (component.type === 'purchase_price') {
                                    formulaValue[component.field_key] = this.orderDetailsData.purchase_cost_price ? parseFloat(this.orderDetailsData.purchase_cost_price) : 0
                                }
                            });
                            if (Object.values(formulaValue).length > 0) {
                                let res = calculate(field.field_formula, formulaValue)
                                res = isNaN(res) || !isFinite(res) ? 0 : res
                                this.$set(this.orderReturnGoodsForm.custom_amount_change, [field.field_key], {})
                                const amount_change = {
                                    value: 0,
                                    text: '',
                                    value_converted: 0,
                                    currency: 'CNY',
                                }
                                if (field.num_display_style === '1') {
                                    amount_change.value = Number(res.toFixed(2))
                                    amount_change.text = amount_change.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    amount_change.value_converted = Number(res.toFixed(2))
                                } else {
                                    amount_change.value = Number(res.toFixed(4))
                                    amount_change.text = (Math.floor(amount_change.value * 10000) / 100).toFixed(2)
                                    amount_change.value_converted = Number(res.toFixed(4))
                                }
                                this.$set(this.orderReturnGoodsForm.custom_amount_change, field.field_key, amount_change)
                                this.returnGoodsOrderAmountInfoComputed(field.field_key)
                            }
                        }
                    }
                })
            }
        },

        //点击换货部位
        handleClickExchangeGoodsPart(row) {
            this.bundle_goods_id = row.order_goods_id
            this.bundle_goods = JSON.parse(JSON.stringify(row))
            this.exchangeGoodsPartVisible = true
        },

        //清空已选商品数量事件
        handleClickClearAllNum() {
            this.bundle_goods.exchange_num = 0
            this.bundle_goods._child.forEach(child => {
                this.$set(child, 'exchange_num', 0)
            })
        },

        //更换整体
        handleChangeAllExchangeNum() {
            this.bundle_goods._child.forEach(child => {
                this.$set(child, 'exchange_num', this.bundle_goods.exchange_num * child.num)
            })
        },

        //配件更换数量改变事件
        handleChangeChildExchangeNum() {
            const result = this.calculateEquipmentReturnNum(this.bundle_goods, 'exchange_num')
            this.$set(this.bundle_goods, 'exchange_num', result)
        },

        //部位更换确定事件
        handleClickExchangeConfirm() {
            if (this.bundle_goods.exchange_num === 0 && this.bundle_goods._child.every(child => child.exchange_num === 0)) return this.$toast.fail('请选择换货数量')
            const bundle_goodsIndex = this.orderExchangeGoods.findIndex(goods => goods.order_goods_id === this.bundle_goods_id)
            this.$set(this.orderExchangeGoods, bundle_goodsIndex, JSON.parse(JSON.stringify(this.bundle_goods)))
            this.bundle_goods = {}
            this.exchangeGoodsPartVisible = false
        },

        //点击关闭损坏换新弹窗
        handleClickExchangeGoodsDialogClose() {
            if (this.orderExchangeGoodsNextStep) {
                this.orderExchangeGoodsNextStep = false
            } else {
                this.orderExchangeGoodsDialog = false
                this.$emit('update:dialogVisible', false)
            }
        },

        //点击换货下一步
        handleClickExchangeGoodsNextStep() {
            this.orderExchangeGoodsForm.exchange_goods = []
            this.orderExchangeGoods.forEach(goods => {
                if (goods.goods_type === 'bundle') {
                    if (goods._child.some(child => child.exchange_num > 0)) {
                        const obj = JSON.parse(JSON.stringify(goods))
                        obj._child = obj._child.filter(child => child.exchange_num > 0)
                        if (obj._child.length) {
                            this.orderExchangeGoodsForm.exchange_goods.push(obj)
                        }
                    }
                } else {
                    if (goods.exchange_num > 0) {
                        this.orderExchangeGoodsForm.exchange_goods.push(goods)
                    }
                }
            })
            if (this.orderExchangeGoodsForm.exchange_goods.length === 0) return this.$toast.fail('请添加损坏换新商品')
            this.orderExchangeGoodsNextStep = !this.orderExchangeGoodsNextStep
            if (this.approval_node_list.length === 0) {
                this.getApprovalNodesList('order_exchange')
            }
        },

        //损坏换新弹窗确认
        handleClickExchangeGoodsDialogConfirm() {
            this.$refs.orderExchangeGoodsForm.validate().then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                const exchange_goods = this.orderExchangeGoodsForm.exchange_goods.map(goods => {
                    if (goods.goods_type === 'bundle') {
                        return {
                            order_goods_id: goods.order_goods_id,
                            exchange_num: goods.exchange_num,
                            _child: goods._child.map(child => {
                                return {
                                    order_goods_id: child.order_goods_id,
                                    exchange_num: child.exchange_num,
                                }
                            }),
                        }
                    } else {
                        return {
                            order_goods_id: goods.order_goods_id,
                            exchange_num: goods.exchange_num,
                        }
                    }
                })
                afterSalesExchange({
                    order_id: this.order_id,
                    after_sales_type: '订单售后-损坏换新', //售后类型
                    order_num: this.orderInfo?.order_num,//	订单编号
                    customer_name: this.orderInfo?.customer_name,//关联客户
                    remarks: this.orderExchangeGoodsForm.remarks,
                    exchange_goods,
                    node_list: this.approval_node_list,
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('损坏换新申请发起成功')
                        this.orderExchangeGoodsDialog = false
                        this.$emit('update:dialogVisible', false)
                        this.$emit('refresh')
                    } else {
                        this.$toast.fail(res.msg)
                    }
                    this.btnDisabled = false
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },

        //退款金额类型切换事件
        handleChangeRefundPriceType() {
            this.orderRefundForm.refund_amount = ''
            this.orderRefundForm.relate_repay = []
            this.refundApplyInfo.relate_repay.forEach(item => {
                this.$set(item, 'checked', false)
            })
        },

        //选择回款计划
        handleClickRelateRepayItem(row) {
            if (row.hasOwnProperty('checked')) {
                this.$set(row, 'checked', !row.checked)
            } else {
                this.$set(row, 'checked', true)
            }
            const records = this.refundApplyInfo.relate_repay.filter(item => item.checked)
            const total = records.reduce((pre, cur) => {
                return pre + Number(cur.payment_amount)
            }, 0)
            this.orderRefundForm.refund_amount = total.toFixed(2)
            this.orderRefundForm.relate_repay = records.map(item => item.receivable_id)
            if (Number(this.orderRefundForm.refund_amount) > Number(this.refundApplyInfo.repay_price)) {
                this.orderRefundForm.refund_amount = Number(this.refundApplyInfo.repay_price).toFixed(2)
                this.$toast.fail('退款金额>回款金额，已自动帮您校准')
            }
        },

        //退款金额输入框失焦事件
        handleRefundAmountBlur() {
            let val = this.orderRefundForm.refund_amount.replace(/[^\d.]/g, '');
            if (Number(val) > Number(this.refundApplyInfo.repay_price)) {
                val = Number(this.refundApplyInfo.repay_price).toFixed(2)
                this.$toast.fail('退款金额>回款金额，已自动帮您校准')
            }
            if (val) {
                this.orderRefundForm.refund_amount = Number(val).toFixed(2)
            } else {
                this.orderRefundForm.price = '0.00'
            }
        },

        //日期确定事件
        handleDateCalenderConfirm(date) {
            if (this.orderRefundDialog) {
                this.orderRefundForm.refund_date = formatDate(date)
            } else if (this.orderRenewalDialog) {
                const val = formatDate(date)
                if (this.batchRenewDateVisible) {
                    this.orderDetailsData.order_goods.forEach(goods => {
                        if (Date.parse(goods.end_at) >= Date.parse(val)) {
                            this.$toast.fail('续期时间不可小于租借到期时间')
                            this.$set(goods, 'renewal_date', '')
                        } else {
                            this.$set(goods, 'renewal_date', val)
                        }
                    })
                    this.batchRenewDateVisible = false
                } else {
                    const goods = this.orderDetailsData.order_goods.find(item => item.order_goods_id === this.bundle_goods_id)
                    if (Date.parse(goods.end_at) >= Date.parse(val)) {
                        return this.$toast.fail('续期时间不可小于租借到期时间')
                    } else {
                        this.$set(goods, 'renewal_date', val)
                    }
                }
            }
            this.showDateCalendar = false
        },

        //单选确定事件
        handleClickRadioOption(data) {
            if (this.orderRefundDialog) {
                this.orderRefundForm.refund_type = data.value
                this.orderRefundForm.refund_type_name = data.label
            }
            this.showRadioPicker = false
        },

        // 点击关闭退款弹窗
        handleClickRefundDialogClose() {
            this.orderRefundDialog = false
            this.$emit('update:dialogVisible', false)
        },

        //退款弹窗确定事件
        handleClickRefundDialogConfirm() {
            this.$refs.orderRefundForm.validate().then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                afterSalesRefund({
                    order_id: this.order_id,
                    after_sales_type: '订单售后-退款', //售后类型
                    order_num: this.orderInfo?.order_num,//	订单编号
                    customer_name: this.orderInfo?.customer_name,//关联客户
                    ...this.orderRefundForm,
                    node_list: this.approval_node_list
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('退款申请发起成功')
                        this.orderRefundDialog = false
                        this.$emit('update:dialogVisible', false)
                        this.$emit('refresh')
                    }
                    this.btnDisabled = false
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },

        //归还数量改变事件
        handleGoodsReturnNumChange(row) {
            if (row._child) {
                row._child.forEach((child, index) => {
                    this.$set(child, 'equipment_return_num', child.num * row.equipment_return_num)
                })
            }
        },

        //点击配件归还
        handleClickReturnAccessories(row) {
            this.bundle_goods_id = row.order_goods_id
            this.returnAccessoriesList = JSON.parse(JSON.stringify(row._child))
            this.returnAccessoriesDialog = true
        },

        //配件归还弹窗取消事件
        handleClickReturnAccessoriesDialogClose() {
            this.returnAccessoriesDialog = false
            this.returnAccessoriesList = []
        },

        //配件归还弹窗确定事件
        handleClickReturnAccessoriesDialogConfirm() {
            if (this.returnAccessoriesList.every(item => !item.equipment_return_num)) return this.$toast.fail('请选择配件归还数量')
            const goods = this.orderEquipmentReturnGoods.find(item => item.order_goods_id === this.bundle_goods_id)
            this.$set(goods, '_child', this.returnAccessoriesList)
            const result = this.calculateEquipmentReturnNum(goods, 'equipment_return_num');
            this.$set(goods, 'equipment_return_num', result)
            this.handleClickReturnAccessoriesDialogClose()
        },

        calculateEquipmentReturnNum(combinedProduct, key) {
            const childItems = combinedProduct._child;
            // 初始化最小返回数量为无穷大
            let minEquipmentReturnNum = Infinity;
            // 遍历每个子部位
            for (let item of childItems) {
                // 计算当前部位的有效返回数量
                const effectiveReturnNum = Math.floor(item[key] / item.num);
                // 更新最小返回数量
                if (effectiveReturnNum < minEquipmentReturnNum) {
                    minEquipmentReturnNum = effectiveReturnNum;
                }
            }
            // 如果最小返回数量为无穷大，表示没有有效数量可用
            return minEquipmentReturnNum === Infinity ? 0 : minEquipmentReturnNum;
        },

        //点击关闭归还弹窗
        handleClickReturnDialogClose() {
            this.orderEquipmentReturnDialog = false
            this.$emit('update:dialogVisible', false)
        },

        //归还弹窗确定事件
        handleClickReturnDialogConfirm() {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            const equipment_return_goods = []
            this.orderEquipmentReturnGoods.forEach(goods => {
                if (goods.goods_type === 'bundle') {
                    if (goods._child.some(item => item.equipment_return_num)) {
                        equipment_return_goods.push({
                            order_goods_id: goods.order_goods_id,
                            equipment_return_num: goods.equipment_return_num,
                            _child: goods._child.filter(child => child.equipment_return_num).map(child => {
                                return {
                                    order_goods_id: child.order_goods_id,
                                    equipment_return_num: child.equipment_return_num,
                                }
                            }),
                        })
                    }
                } else {
                    if (goods.equipment_return_num) {
                        equipment_return_goods.push({
                            order_goods_id: goods.order_goods_id,
                            equipment_return_num: goods.equipment_return_num,
                        })
                    }
                }
            })
            if (equipment_return_goods.length === 0) return this.$toast.fail('请选择归还产品')
            afterSalesEquipmentReturn({
                order_id: this.order_id,
                after_sales_type: '订单售后-归还', //售后类型
                order_num: this.orderInfo?.order_num,//	订单编号
                customer_name: this.orderInfo?.customer_name,//关联客户
                equipment_return_goods: equipment_return_goods,
                node_list: this.approval_node_list,
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('归还申请发起成功')
                    this.orderEquipmentReturnDialog = false
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh')
                }
                this.btnDisabled = false
            })
        },

        //选择续期时间
        handleClickSelectRenewalDate(row) {
            this.bundle_goods_id = row.order_goods_id
            this.showDateCalendar = true
        },

        //批量选择续期时间
        handleClickBatchRenewDate() {
            this.batchRenewDateVisible = true
            this.showDateCalendar = true
        },

        //点击关闭续租弹窗
        handleClickRenewDialogClose() {
            this.orderRenewalDialog = false
            this.$emit('update:dialogVisible', false)
        },

        //续租弹窗确定事件
        handleClickRenewDialogConfirm() {
            if (this.orderDetailsData.order_goods.every(item => !item.renewal_date)) return this.$toast.fail('请至少选择一个商品的续租时间')
            this.$refs.orderRenewalForm.validate().then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                afterSalesRenewal({
                    order_id: this.order_id,
                    after_sales_type: '订单售后-续租', //售后类型
                    order_num: this.orderInfo?.order_num,//	订单编号
                    customer_name: this.orderInfo?.customer_name,//关联客户
                    renewal_goods: this.orderDetailsData.order_goods.filter(item => item.renewal_date).map(item => {
                        return {
                            order_goods_id: item.order_goods_id,
                            renewal_date: item.renewal_date,
                        }
                    }),
                    remarks: this.orderRenewalForm.remarks,
                    node_list: this.approval_node_list,
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('续租申请发起成功')
                        this.handleClickRenewDialogClose()
                        this.$emit('refresh')
                    }
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },

        //点击全部销售
        handleClickAllForSale() {
            this.orderDetailsData.order_goods.forEach(row => {
                if (row.type === 2 && row.is_sale === 1) {
                    this.$set(row, 'sale_num', row.max_to_sale_num)
                    this.handleForSaleNumChange(row)
                }
            })
        },

        //转销售数量变化事件
        handleForSaleNumChange(row) {
            if (!row.sale_price.value) {
                if (row.goods_type === 'bundle') {
                    row.sale_guide_price = row._child.reduce((acc, cur) => {
                        return acc + Number(cur.sale_guide_price)
                    }, 0)
                }
                this.$set(row.sale_price, 'value', row.sale_guide_price ? Number(row.sale_guide_price) : 0)
                this.$set(row.sale_price, 'text', row.sale_price.value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
                this.$set(row.sale_price, 'value_converted', row.sale_price.value)
            }
            this.$set(row.sale_subtotal_price, 'value', row.sale_price.value ? Number(row.sale_num) * Number(row.sale_price.value) : 0)
            this.$set(row.sale_subtotal_price, 'text', row.sale_subtotal_price.value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            this.$set(row.sale_subtotal_price, 'value_converted', row.sale_subtotal_price.value)
        },

        //销售单价输入框失焦事件
        handleSalePriceBlur(row) {
            let val = row.sale_price.text.replace(/[^\d.]/g, '')
            if (val) {
                row.sale_price.value = Number(val)
                row.sale_price.text = row.sale_price.value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                row.sale_price.value_converted = row.sale_price.value
            } else {
                row.sale_price.value = 0
                row.sale_price.text = '0.00'
                row.sale_price.value_converted = 0
            }
            this.handleForSaleNumChange(row)
        },

        //租借转销售下一步
        handleLeaseForSaleNextStep() {
            if (this.orderDetailsData.order_goods.every(item => !item.sale_num)) return this.$toast.fail('请至少销售一个商品')
            this.orderLeaseForSaleNextStep = !this.orderLeaseForSaleNextStep
            if (this.orderLeaseForSaleNextStep) {
                if (this.approval_node_list.length === 0) {
                    this.getApprovalNodesList('order_rental_to_sale')
                }
                //计算订单销售商品总成本
                const total_goods_cost_price = this.orderDetailsData.order_goods.reduce((total, item) => {
                    if (item.type === 2 && item.is_sale === 1 && item.sale_num) {
                        return total + (parseFloat(item.cost_price) * item.sale_num);
                    }
                    return total; // 如果不满足条件，保持总值不变
                }, 0);
                this.leaseForSaleForm.goods_cost_price = (total_goods_cost_price + Number(this.orderDetailsData.goods_cost_price)).toFixed(2)
                //计算订单转销售后的订单总金额= 原订单总金额 - 转销售数量 * 转销售前的租借金额  + 转销售商品的总金额
                const toSaleTotalLeasePrice = this.orderDetailsData.order_goods.reduce((total, item) => {
                    const subtotal = (item.type === 1) ? 0 : item.sale_num ? item.sale_num * Number(item.price.value) : 0
                    return total + subtotal;
                }, 0);
                const total_price = Number(this.orderDetailsData.total_price.value) - toSaleTotalLeasePrice + this.toSaleTotalAmount
                total_price.log
                this.leaseForSaleForm.total_price.value = total_price
                this.leaseForSaleForm.total_price.text = total_price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                this.leaseForSaleForm.total_price.value_converted = total_price
                this.leaseForSaleForm.rental_to_sale_goods = this.orderDetailsData.order_goods.filter(item => {
                    return item.type === 2 && item.is_sale === 1 && item.sale_num
                })
                this.leaseForSaleOrderAmountInfoComputed('total_price')
                this.leaseForSaleOrderAmountInfoComputed('product_cost')
                this.leaseForSaleOrderAmountInfoComputed('product_total_price')
            } else {
                this.leaseForSaleForm.goods_cost_price = 0
                this.leaseForSaleForm.total_price = {
                    value: 0,
                    text: "",
                    value_converted: 0,
                    currency: "CNY"
                }
                this.leaseForSaleForm.rental_to_sale_goods = []
                this.leaseForSaleForm.custom_amount_change = []
            }
        },

        //租借转销售后订单金额信息重新计算
        leaseForSaleOrderAmountInfoComputed(field_key) {
            if (this.order_amount_compute_mode.length) {
                this.order_amount_compute_mode.forEach(field => {
                    if (field.field_formula.includes(field_key)) {
                        //拿出公式列表所有type为component的组件
                        const components = field.formula_list.filter(formula => formula.type === 'component' || formula.type === 'product_cost' || formula.type === 'product_total_price' || formula.type === 'purchase_price')
                        if (components.length) {
                            //接口需要的数据
                            const formulaValue = {}
                            components.forEach(component => {
                                if (component.type === 'component') {
                                    if (component.field_type === 'order_amount_compute_mode') {
                                        //订单金额信息，先从金额信息变化中寻找，如果有则使用最新的值，没有再从详情中取
                                        const order_amount_compute_mode = this.leaseForSaleForm.custom_amount_change.find(item => item.field_key === component.field_key)
                                        formulaValue[component.field_key] = order_amount_compute_mode ? Number(order_amount_compute_mode.new_value.value) : Number(this.orderDetailsData[component.field_key].value)
                                    } else if (component.field_type === 'money_compute_mode') {
                                        //一般指订单总金额
                                        formulaValue[component.field_key] = Number(this.leaseForSaleForm.total_price.value)
                                    }
                                } else if (component.type === 'product_cost' || component.type === 'product_total_price') {
                                    let filteredGoods = []
                                    if (!component.commodity_value_config || component.commodity_value_config.length === 0) {
                                        filteredGoods = this.orderDetailsData.order_goods;
                                    } else {
                                        component.commodity_value_config.forEach(config => {
                                            if (config.type === 'category') {
                                                this.orderDetailsData.order_goods.forEach(good => {
                                                    if (good.category_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            } else if (config.type === 'goods') {
                                                this.orderDetailsData.order_goods.forEach(good => {
                                                    if (good.goods_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    if (component.type === 'product_cost') {
                                        if (field.applicable_products === 'sale') {
                                            //计算销售商品的总成本，需要加上租借转销售的数量*商品成本
                                            formulaValue[component.field_key] = filteredGoods.reduce((total, item) => {
                                                const sub_cost = item.type === 1 ? parseFloat(item.cost_price) * item.num : item.sale_num ? parseFloat(item.cost_price) * item.sale_num : 0
                                                return total + sub_cost;
                                            }, 0);
                                        } else if (field.applicable_products === 'lease') {
                                            formulaValue[component.field_key] = filteredGoods.reduce((total, item) => {
                                                const sub_cost = item.type === 2 ? item.sale_num ? parseFloat(item.cost_price) * (item.num - item.sale_num) : parseFloat(item.cost_price) * item.num : 0
                                                return total + sub_cost;
                                            }, 0);
                                        } else {
                                            formulaValue[component.field_key] = filteredGoods.reduce((sum, item) => sum + parseFloat(item.cost_price) * item.num, 0);
                                        }
                                    } else {
                                        //计算商品的总价
                                        if (field.applicable_products === 'sale') {
                                            formulaValue[component.field_key] = filteredGoods.reduce((total, item) => {
                                                const subtotal = item.type === 1 ? Number(item.subtotal_price.value) : item.sale_num ? Number(item.sale_subtotal_price.value) : 0
                                                return total + subtotal;
                                            }, 0);
                                        } else if (field.applicable_products === 'lease') {
                                            formulaValue[component.field_key] = filteredGoods.reduce((total, item) => {
                                                const subtotal = item.type === 2 ? item.sale_num ? (item.num - item.sale_num) * Number(item.price.value) : Number(item.subtotal_price.value) : 0
                                                return total + subtotal;
                                            }, 0);
                                        } else {
                                            formulaValue[component.field_key] = filteredGoods.reduce((total, item) => {
                                                const subtotal = item.type === 1 || !item.sale_num ? Number(item.subtotal_price.value) : Number(item.sale_subtotal_price.value) + (item.num - item.sale_num) * Number(item.price.value)
                                                return total + subtotal;
                                            }, 0);
                                        }
                                    }
                                } else if (component.type === 'purchase_price') {
                                    formulaValue[component.field_key] = this.orderDetailsData.purchase_cost_price ? parseFloat(this.orderDetailsData.purchase_cost_price) : 0
                                }
                            })
                            if (Object.values(formulaValue).length > 0) {
                                let res = calculate(field.field_formula, formulaValue)
                                res = isNaN(res) || !isFinite(res) ? 0 : res
                                const custom_amount_change = {
                                    field_name: field.field_name,
                                    field_key: field.field_key,
                                    new_value: {},
                                    old_value: this.orderDetailsData[field.field_key] ? this.orderDetailsData[field.field_key] : {},
                                }
                                if (field.num_display_style === '1') {
                                    custom_amount_change.new_value.value = Number(res.toFixed(2))
                                    custom_amount_change.new_value.text = custom_amount_change.new_value.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    custom_amount_change.new_value.value_converted = Number(res.toFixed(2))
                                } else {
                                    custom_amount_change.new_value.value = Number(res.toFixed(4))
                                    custom_amount_change.new_value.text = ((Math.floor(custom_amount_change.new_value.value * 10000) / 100).toFixed(2))
                                    custom_amount_change.new_value.value_converted = Number(res.toFixed(4))
                                }
                                //如果旧值和新值不一致，则添加到custom_amount_change数组中
                                if (custom_amount_change.old_value.hasOwnProperty('value') && custom_amount_change.old_value.value !== custom_amount_change.new_value.value) {
                                    const index = this.leaseForSaleForm.custom_amount_change.findIndex(item => item.field_key === custom_amount_change.field_key)
                                    if (index < 0) {
                                        this.leaseForSaleForm.custom_amount_change.push(custom_amount_change)
                                    } else {
                                        this.$set(this.leaseForSaleForm.custom_amount_change[index], 'new_value', custom_amount_change.new_value)
                                    }
                                }
                                this.leaseForSaleOrderAmountInfoComputed(field.field_key)
                            }
                        }
                    }
                })
            }
        },

        //点击关闭租借转销售弹窗
        handleClickLeaseForSaleDialogClose() {
            if (this.orderLeaseForSaleNextStep) {
                this.orderLeaseForSaleNextStep = false
            } else {
                this.orderLeaseForSaleDialog = false
                this.$emit('update:dialogVisible', false)
            }
        },

        //租借转销售弹窗确定事件
        handleClickLeaseForSaleDialogConfirm() {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            // this.btnDisabled = true
            const rental_to_sale_goods = this.leaseForSaleForm.rental_to_sale_goods.map(item => {
                return {
                    order_goods_id: item.order_goods_id,
                    sale_num: item.sale_num,
                    sale_price: item.sale_price,
                    sale_subtotal_price: item.sale_subtotal_price,
                    cost_price: item.cost_price,
                    sale_guide_price: item.sale_guide_price,
                }
            })
            afterSalesRentalToSale({
                order_id: this.order_id,
                after_sales_type: '订单售后-租借转销售', //售后类型
                order_num: this.orderInfo?.order_num,//	订单编号
                customer_name: this.orderInfo?.customer_name,//关联客户
                rental_to_sale_goods,
                goods_cost_price: this.leaseForSaleForm.goods_cost_price,
                custom_amount_change: this.leaseForSaleForm.custom_amount_change,
                total_price: this.leaseForSaleForm.total_price,
                node_list: this.approval_node_list
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('租借转销售申请发起成功')
                    this.orderLeaseForSaleDialog = false
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh')
                }
            })
        },

        //点击打开组合产品的配置
        handleClickExpandConfig(row) {
            if (row.hasOwnProperty('is_expand')) {
                row.is_expand = !row.is_expand
            } else {
                this.$set(row, 'is_expand', true)
            }
        },
    },
}
</script>
<style lang="scss">
.after_sale_overlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .after_sale_type_list {
        width: 90%;
        height: 470px;
        margin: 0 auto;
        background-color: #FFFFFF;
        padding-bottom: 10px;
        border-radius: 8px;

        .after_sale_type_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 16px;
            box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
            margin-bottom: 10px;

            .title {
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
            }
        }

        .after_sale_type_item {
            padding: 8px 28px;
            border-radius: 6px;
            cursor: pointer;

            .iconfont {
                font-size: 14px;
                margin-right: 4px;
            }

            .type_name {
                font-size: 14px;
                color: #333333;
                font-weight: 700;
                line-height: 22px;
            }

            .desc {
                color: #999999;
                font-size: 12px;
                line-height: 18px;
                margin-top: 2px;
            }

            &:hover {
                background: rgba(0, 0, 0, 0.04);
            }
        }
    }

    .next_step_btn_wrap {
        padding: 10px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #FFFFFF;
        border-radius: 8px 8px 0 0;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.04);

        .total_text {
            font-size: 14px;
            font-weight: 700;
            line-height: 22px;
            color: #333333;
        }

        .total_amount {
            font-weight: 700;
            line-height: 22px;
            color: #E44144;
        }
    }

    .van-notice-bar__wrap {
        .icon-S_jinggao_shixin {
            color: #F0AA32;
        }

        .notice {
            flex: 1;
            white-space: normal;
            font-size: 12px;
            line-height: 18px;
        }
    }

    .hint_text {
        line-height: 18px;
        font-size: 12px;
        color: #999999;
        background-color: #FFFFFF;
        padding: 0 16px 12px;
    }

    .add_approval_select_process {
        padding: 12px 16px 0;
        background-color: #FFFFFF;
    }

    .radio_option_wrap {
        width: 100%;
        height: 100%;
        padding: 0 16px 35px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .radio_option_list {
            max-height: calc(100% - 90px);
            overflow-y: auto;

            .radio_option_item {
                background-color: #FFFFFF;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                padding: 10px 0;
                color: #666666;
                border-bottom: 1px solid #DEDEDE;

                &:first-child {
                    border-radius: 8px 8px 0 0;
                }

                &:last-child {
                    border-bottom: none;
                    border-radius: 0 0 8px 8px;
                }
            }
        }

        .cancel_btn {
            background-color: #FFFFFF;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-radius: 8px;
            box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
            margin-top: 10px;
        }
    }

    .returna_ccessories_list {
        .returna_ccessories_item {
            padding: 10px 16px;
            background-color: #FFFFFF;
            margin-bottom: 4px;

            .goods_sku_name {
                padding-bottom: 10px;
                border-bottom: 1px solid #E8E8E8;
                margin-bottom: 10px;
                font-size: 12px;
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }
        }
    }

    .field_label {
        color: #999999;
    }
}
</style>